import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getNewsInformationAPI from '../../api/get-news-information';
import { INewsInformationResponses } from '../../utils/types/admin-types';
import { rejectDivisionNews, requestDivisionNews, reсeiveDivisionNews } from '../actions/main-page';

const getNewsInformation = function* getNewsInformation() {
  try {
    const response: INewsInformationResponses = yield call(getNewsInformationAPI);
    yield put(reсeiveDivisionNews({ division: response }));
  } catch (error) {
    yield put(rejectDivisionNews({ error }));
  }
};

export default function* getNewsInformationWatcher() {
  yield takeLatest(requestDivisionNews, getNewsInformation);
}
